export default __webpack_public_path__ + "static/Loomis_MI-0206.png";